import { createValidationMessage } from '../../../../validation/create-validation-message'


export default (task, processInstance, taskName, eventName, context) => {

    const messageList = []

    const ReasonMedicalEval = context.ReasonMedicalEval
    if (ReasonMedicalEval) {
        messageList.push(createValidationMessage("The reason for 'Medical Evaluation Reason' should be empty.", 'checkMedicalEvaluationTracking.checkMedicalEvaluationTracking'))
    }

    if (eventName === 'cannot_be_treated') {
        const cannotBeTreatedReason = context.cannotBeTreatedReason
        if (!cannotBeTreatedReason) {
            messageList.push(createValidationMessage("Please add the reason for 'cannot be treated' before proceeding.", 'checkDeliveryTracking.checkDeliveryTracking'))
        }
    }

    return messageList
}



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/check-treatability-validator.js